import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { DentalAttendance } from "@/@types/esus/DentalAttendance";

type IndicatorEsbB2CitizenHistoryItemProps = {
	dentalAttendance: DentalAttendance;
};

export function IndicatorEsbB2CitizenHistoryItem({
	dentalAttendance,
}: Readonly<IndicatorEsbB2CitizenHistoryItemProps>) {
	return (
		<>
			{dentalAttendance.dentalAppointmentType?.description && (
				<Row>
					<Col>
						<p>
							<span className="fw-bold text-primary">Tipo de atendimento: </span>
							{dentalAttendance.dentalAppointmentType.description ?? "N/A"}
						</p>
					</Col>
				</Row>
			)}
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{dentalAttendance.healthTeam1?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{dentalAttendance.healthUnit1?.name ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{dentalAttendance.professional1?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{dentalAttendance.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			{Boolean(dentalAttendance.conductTreatmentCompleted) && (
				<Row>
					<Col>
						<p>
							<span className="fw-bold text-primary">Conduta: </span>
							{Boolean(dentalAttendance.conductTreatmentCompleted)
								? "Tratamento Concluído"
								: "N/A"}
						</p>
					</Col>
				</Row>
			)}
		</>
	);
}
